var React = require('react');

function Bone (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)"},React.createElement("path",{"d":"M15 3a3 3 0 0 1 3 3 3 3 0 1 1-2.12 5.122L11.12 15.88a3 3 0 1 1-5.117 2.297V18h-.176a3 3 0 1 1 2.298-5.115l4.758-4.758a3 3 0 0 1 2.12-5.122L15 3z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"})));
}

Bone.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Bone;

Bone.default = Bone;
